module.exports = __webpack_public_path__ + "static/img/11.b5cb42d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/1/sp/11.png
// module id = gzNS
// module chunks = 0